"use client";

import {For, SegmentGroup} from "@chakra-ui/react";
import * as React from "react";

interface Item {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface SegmentedControlProps extends SegmentGroup.RootProps {
  items: Array<string | Item>;
}

function normalize(items: Array<string | Item>): Item[] {
  return items.map(item => {
    if (typeof item === "string") return {value: item, label: item};
    return item;
  });
}

export const SegmentedControl = React.forwardRef<HTMLDivElement, SegmentedControlProps>(
  function SegmentedControl(props, ref) {
    const {items, colorPalette = "gray", ...rest} = props;
    const data = React.useMemo(() => normalize(items), [items]);
    const indicatorBg = colorPalette === "gray" ? "white" : `${colorPalette}.subtle`;
    const indicatorShadowColor = `${colorPalette}.muted`;

    return (
      <SegmentGroup.Root ref={ref} {...rest} colorPalette={colorPalette}>
        <SegmentGroup.Indicator
          bg={`${indicatorBg} !important`}
          shadowColor={`${indicatorShadowColor}`}
          shadow="0 0 0px 1px var(--shadow-color)"
          transitionProperty="background, top, left, width, height, shadow !important"
        />
        <For each={data}>
          {item => (
            <SegmentGroup.Item
              key={item.value}
              value={item.value}
              disabled={item.disabled}
              _checked={{color: "colorPalette.fg"}}
            >
              <SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText>
              <SegmentGroup.ItemHiddenInput />
            </SegmentGroup.Item>
          )}
        </For>
      </SegmentGroup.Root>
    );
  },
);
